import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  function got(path: string) {
    navigate("/category/" + path);
    window.scrollTo(0, 0);
  }
  return (
    <footer className="bg-black text-white min-h-[30vh] w-full mt-8 flex flex-col items-center">
      <div className="h-full flex flex-col justify-center sm:items-start items-center w-11/12 md:w-10/12 gap-7 sm:gap-10">
        <div className="flex md:flex-row flex-col justify-between items-center sm:items-start w-full md:items-end gap-4">
          <p className="text-xl sm:text-left text-center font-extrabold border-t-4 pt-4 border-primary">
            audiophile.
          </p>
          <ul className="sm:inline-flex sm:flex-row flex flex-colx bg-red-700x justify-between items-center flex-wrap w-full sm:w-max gap-4 text-[10px] text-white/70 font-semibold !tracking-wide">
            <Link to="/" className="cursor-pointer uppercase hover:text-white">
              HOME
            </Link>
            <button
              onClick={() => got("Headphones")}
              className="cursor-pointer uppercase hover:text-white"
            >
              HEADPHONES
            </button>
            <button
              onClick={() => got("Speakers")}
              className="cursor-pointer uppercase hover:text-white"
            >
              SPEAKERS
            </button>
            <button
              onClick={() => got("Earphones")}
              className="cursor-pointer uppercase hover:text-white"
            >
              EARPHONES
            </button>
          </ul>
        </div>
        <div className="flex justify-between items-end">
          {/* <p className="text-xs sm:text-sm font-medium tracking-wide sm:text-left text-center md:w-6/12 text-white/70">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.{" "}
          </p> */}
          <div className="hidden md:flex gap-3">
            <i className="fa-brands fa-square-facebook !text-[20px] cursor-pointer"></i>
            <i className="fa-brands fa-x-twitter !text-[20px] cursor-pointer"></i>
            <i className="fa-brands fa-instagram !text-[20px] cursor-pointer"></i>
          </div>
        </div>
        <div className="flex sm:flex-row flex-col w-full gap-6 pb-10 justify-between items-center">
          <p className="text-xs font-medium text-white/70">
            Copyright 2021. All rights reserved.
          </p>
          <div className="md:hidden flex gap-3">
            <i className="fa-brands fa-square-facebook !text-[20px] cursor-pointer"></i>
            <i className="fa-brands fa-x-twitter !text-[20px] cursor-pointer"></i>
            <i className="fa-brands fa-instagram !text-[20px] cursor-pointer"></i>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
